import CircularProgress from "@mui/material/CircularProgress";
import { Box, styled, useTheme } from "@mui/material";
import { SkipIcon, CheckFilledIcon } from "src/foundations/icons";

export interface SenecCircularProgressProps {
    sizeInPx?: number;
    thickness?: number;
    value: number;
    skipped?: boolean;
}

const CustomCircularProgress = styled(CircularProgress)(({ theme }) => ({
    color: `${theme.palette.mode === "light" ? theme.palette.primary.main : theme.palette.grey[400]} !important`,
}));

export const SenecCircularProgress: React.FC<SenecCircularProgressProps> = ({
    sizeInPx = 40,
    thickness = 3.6,
    value,
    skipped = false,
    ...props
}) => {
    const theme = useTheme();

    return (
        <Box sx={{ position: "relative", display: "inline-flex", alignItems: "center", justifyContent: "center" }}>
            {skipped ? (
                <SkipIcon
                    sx={{ color: (theme) => `${theme.palette.grey[300]} !important`, fontSize: `${sizeInPx}px` }}
                    data-testid={"SkipIcon"}
                />
            ) : (
                <>
                    {value < 100 ? (
                        <>
                            <CustomCircularProgress
                                variant="determinate"
                                value={100}
                                size={sizeInPx}
                                thickness={thickness}
                                sx={{ color: (theme) => `${theme.palette.grey[400]} !important` }}
                                {...props}
                            />
                            <CustomCircularProgress
                                variant="determinate"
                                value={value}
                                size={sizeInPx}
                                thickness={thickness}
                                sx={{ position: "absolute" }}
                                {...props}
                            />
                        </>
                    ) : (
                        <CheckFilledIcon
                            data-testid="CheckFilledIcon"
                            sx={{ color: theme.palette.primary.main, fontSize: `${sizeInPx}px` }}
                        />
                    )}
                </>
            )}
        </Box>
    );
};
